import React from 'react';

import * as api from '_core/utils/api';


const DEFAULT_CONFIG = {
  classic_points_scale: 2
};


export const ConfigContext = React.createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = React.useState(DEFAULT_CONFIG);
  
  React.useEffect(() => {
    api.getClientConfig()
      .then(setConfig)
      .catch((error) => console.error(error));
  }, []);
  
  
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => React.useContext(ConfigContext);
